import httpClient from "@/httpClient"

const getAdminCustomFieldsConfiguration = (params) => httpClient.get(
  '/{currentCompanySlug}/records/customFields/configurations', { params },
)

const getAdminSectionsList = () => httpClient.get(
  '/{currentCompanySlug}/records/customFields/sections',
)

const createSection = (payload) => httpClient.post(
  '/{currentCompanySlug}/records/customFields/sections',
  payload,
)

const updateSection = (payload) => httpClient.put(
  `/{currentCompanySlug}/records/customFields/sections/${payload.slug}`,
  payload,
)

const deleteSection = (sectionSlug) => httpClient.delete(
  `/{currentCompanySlug}/records/customFields/sections/${sectionSlug}`,
)

const reorderSections = (payload) => httpClient.post(
  '/{currentCompanySlug}/records/customFields/sections/reorder',
  { data: payload },
)

const createAdminSectionField = (payload) => httpClient.post(
  '{currentCompanySlug}/records/customFields/configurations', payload,
)

export const updateAdminSectionField = (field, isSilent = true) => httpClient.put(
  `{currentCompanySlug}/records/customFields/configurations/${field.slug}`,
  field,
  {
    headers: isSilent ? {
      notification: 'silent',
    } : {},
  },
)

const deleteAdminSectionField = (fieldSlug, forced = false) => httpClient.delete(
  `{currentCompanySlug}/records/customFields/configurations/${fieldSlug}`,
  {
    data: { forced },
    headers: {
      notification: 'silent',
    },
  },
)

const deleteAdminSectionChildObject = (fieldSlug, columnName, forced = false) => httpClient.delete(
  `{currentCompanySlug}/records/customFields/configurations/${fieldSlug}/${columnName}`,
  {
    data: { forced },
    headers: {
      notification: 'silent',
    },
  },
)

const updateCustomFieldsPosition = (payload) => httpClient.post(
  '{currentCompanySlug}/records/customFields/configurations/reorder',
  payload,
)

const updateCustomFieldsObjectChildPosition = (customFieldConfigurationSlug, payload) => httpClient.post(
  `{currentCompanySlug}/records/customFields/configurations/${customFieldConfigurationSlug}/objectConfiguration/reorder`,
  payload,
)

export const getImportList = (payload = {}) => {
  return httpClient.get(
    "/{currentCompanySlug}/queued-import",
    {
      params: payload,
    },
  )
}

export const getImportById = (uuid) => httpClient.get(
  `/{currentCompanySlug}/queued-import/${uuid}`,
)

export const getImportResultFile = (uuid) => httpClient.get(
  `/{currentCompanySlug}/queued-import/${uuid}/download`,
  {
    responseType: 'blob',
  },
)

export const cancelImportById = (uuid) => httpClient.put(
  `/{currentCompanySlug}/queued-import/${uuid}/cancel`,
)

const importRecordInsert = (file) => httpClient({
  method: 'POST',
  url: '{currentCompanySlug}/quotes/import/insert',
  data: file,
  headers: { 'Content-Type': 'multipart/form-data' },
})

const importRecordUpdate = (file) => httpClient({
  method: 'POST',
  url: '{currentCompanySlug}/quotes/import/update',
  data: file,
  headers: { 'Content-Type': 'multipart/form-data' },
})

const importRecordUpsert = (file) => httpClient({
  method: 'POST',
  url: '{currentCompanySlug}/quotes/import/upsert',
  data: file,
  headers: { 'Content-Type': 'multipart/form-data' },
})

const importRecordDelete = (file) => httpClient({
  method: 'POST',
  url: '{currentCompanySlug}/quotes/import/delete',
  data: file,
  headers: { 'Content-Type': 'multipart/form-data' },
})

const importChildRecordInsert = (file) => httpClient({
  method: 'POST',
  url: '{currentCompanySlug}/custom-field-objects/import/insert',
  data: file,
  headers: { 'Content-Type': 'multipart/form-data' },
})

const importChildRecordUpdate = (file) => httpClient({
  method: 'POST',
  url: '{currentCompanySlug}/custom-field-objects/import/update',
  data: file,
  headers: { 'Content-Type': 'multipart/form-data' },
})

const importChildRecordDelete = (file) => httpClient({
  method: 'POST',
  url: '{currentCompanySlug}/custom-field-objects/import/delete',
  data: file,
  headers: { 'Content-Type': 'multipart/form-data' },
})

const importChildRecordUpsert = (file) => httpClient({
  method: 'POST',
  url: '{currentCompanySlug}/custom-field-objects/import/upsert',
  data: file,
  headers: { 'Content-Type': 'multipart/form-data' },
})

const importRecordTemplate = (payload) => httpClient({
  method: 'GET',
  url: '{currentCompanySlug}/quotes/import/template',
  params: payload,
  responseType: 'blob',
})

const importChildRecordTemplate = (payload) => httpClient({
  method: 'GET',
  url: '{currentCompanySlug}/custom-field-objects/import/template',
  params: payload,
  responseType: 'blob',
})

// file templates
const getFileTemplates = () => httpClient.get('{currentCompanySlug}/supplierCompany/template-documents')

const updateTemplateFile = (payload) => httpClient({
  method: 'POST',
  url: `{currentCompanySlug}/supplierCompany/template-documents/${payload.id}/file`,
  data: payload.file,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
})

const updateFileTemplate = (payload) => httpClient.patch(
  `{currentCompanySlug}/supplierCompany/template-documents/${payload.id}`,
  payload.data,
)

const changeFileTemplatesOrder = (payload) => httpClient.post('{currentCompanySlug}/supplierCompany/template-documents/reorder', payload)

const deleteFileTemplate = (id) => httpClient.delete(
  `{currentCompanySlug}/supplierCompany/template-documents/${id}`,
)

const createTemplateFile = (payload) => httpClient({
  method: 'POST',
  url: '{currentCompanySlug}/supplierCompany/template-documents',
  data: payload,
  headers: { 'Content-Type': 'multipart/form-data' },
})

const loadDocumentKeyspases = () => httpClient.get('{currentCompanySlug}/supplierCompany/template-documents/keyspaces')

const loadFunctionsConfigurations = () => httpClient.get('{currentCompanySlug}/quotes/customFields/functions')

const loadLinkedCompanies = (accountId, tenantId) => httpClient.get(`{currentCompanySlug}/accounts/${accountId}/companies?fromTenant=${tenantId}`)
const loadLinkedCompaniesCustomFields = (companySlug) => httpClient.get(`${companySlug}/records/customFields/configurations`)

const loadLinkedCompaniesConfig = (companySlug = null) => httpClient.get(`${companySlug || '{currentCompanySlug}'}/suppliers/${companySlug}/application-configuration`)

export const getEntityConditions = (companySlug = null) => httpClient.get(`${companySlug || '{currentCompanySlug}'}/display-conditions`)

const createEntityConditions = (payload) => httpClient.post(`{currentCompanySlug}/display-conditions`, payload)

const updateEntityConditions = (id, payload) => httpClient.put(`{currentCompanySlug}/display-conditions/${id}`, payload)

const deleteEntityConditions = (id) => httpClient.delete(`{currentCompanySlug}/display-conditions/${id}`)

const changeRecordChangeLogsActive = (payload) => httpClient.patch('/{currentCompanySlug}/features',
  {
    displayRecordChangeLog: payload,
  },
)

export default {
  getAdminCustomFieldsConfiguration,
  getImportList,
  createSection,
  updateSection,
  deleteSection,
  reorderSections,
  getAdminSectionsList,
  importRecordInsert,
  importRecordUpdate,
  importRecordUpsert,
  importRecordDelete,
  importChildRecordDelete,
  importChildRecordInsert,
  importChildRecordUpdate,
  importChildRecordUpsert,
  importRecordTemplate,
  importChildRecordTemplate,
  getFileTemplates,
  updateTemplateFile,
  updateFileTemplate,
  changeFileTemplatesOrder,
  createTemplateFile,
  deleteFileTemplate,
  loadDocumentKeyspases,
  createAdminSectionField,
  updateAdminSectionField,
  deleteAdminSectionField,
  deleteAdminSectionChildObject,
  updateCustomFieldsPosition,
  updateCustomFieldsObjectChildPosition,
  loadFunctionsConfigurations,
  loadLinkedCompanies,
  loadLinkedCompaniesCustomFields,
  loadLinkedCompaniesConfig,
  getEntityConditions,
  createEntityConditions,
  updateEntityConditions,
  deleteEntityConditions,
  changeRecordChangeLogsActive,
}
